export function Step4MeasurementSection() {
  return (
    <section className="grad-step4 border-y border-brand-100">
      <div className="mx-auto grid max-w-[1200px] grid-cols-1 items-center gap-12 px-6 py-32 lg:grid-cols-[minmax(0,440px)_minmax(0,1fr)]">
        <div>
          <div className="flex items-center gap-2">
            <span className="inline-flex items-center gap-1 rounded-md bg-brand-50 px-2.5 py-1 text-[11px] font-bold tracking-wider text-brand-700">
              STEP 5 · 効果測定
            </span>
            <span className="rounded-full bg-brand-600 px-2.5 py-0.5 text-[10px] font-bold tracking-wider text-white">
              NEW
            </span>
          </div>
          <h3 className="mt-5 text-[40px] font-bold leading-[1.18] tracking-tight md:text-[48px]">
            <span className="whitespace-nowrap">反応を測定し、</span>
            <br />
            <span className="whitespace-nowrap">次の一手を最適化。</span>
          </h3>
          <p className="mt-5 text-[14px] leading-relaxed text-ink-600">
            送信後の反応を自動でトラッキング。成果の可視化と改善提案で、
            <br />
            アプローチの精度を継続的に高めます。
          </p>
          <ul className="mt-6 space-y-3 text-[14px]">
            <li className="flex items-center gap-2.5">
              <span className="grid h-5 w-5 place-items-center rounded-md bg-brand-600 text-white">
                <span className="mi text-[14px]">check</span>
              </span>
              開封・クリック・返信をリアルタイムで可視化
            </li>
            <li className="flex items-center gap-2.5">
              <span className="grid h-5 w-5 place-items-center rounded-md bg-brand-600 text-white">
                <span className="mi text-[14px]">check</span>
              </span>
              成果の高い件名・本文を自動で分析
            </li>
            <li className="flex items-center gap-2.5">
              <span className="grid h-5 w-5 place-items-center rounded-md bg-brand-600 text-white">
                <span className="mi text-[14px]">check</span>
              </span>
              GoogleAnalytics4連携でアクセス状況を確認
            </li>
          </ul>
        </div>

        <div>
          <img
            alt="効果測定ダッシュボード"
            className="w-full rounded-2xl bg-white shadow-card ring-1 ring-ink-200/60"
            src="/images/lp/step4-effect.png"
          />
        </div>
      </div>
    </section>
  );
}
